/* eslint-disable @next/next/no-img-element */
import useIsMobile from "@/helpers/useIsMobile";
import { Archetype as ArchetypeModelNPM } from "@dimensional-engineering/dimensional-models";
import TraitScoreLarge from "../../../shared/TraitScoreLarge/TraitScoreLarge";

import styles from "./LargeArchetype.module.css";
import { archetypeMapper } from "@/assets/traitInfo/dimensionData";

type ArchetypeModel = {
  archetype: ArchetypeModelNPM;
  score?: number | null;
  hasBorder?: boolean;
};

export default function LargeArchetype(props: ArchetypeModel) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className={styles.architypeBody}>
        <p className={styles.topText}>
          {archetypeMapper[props.archetype.dimensionSlug]} <br />
          Archetype
        </p>

        <svg
          width="136"
          height="136"
          viewBox="0 0 136 136"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <clipPath id="ArchetypeImageClipPathLarge">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M127.886 127.372C134.157 127.372 138.051 120.553 134.863 115.152L74.9767 13.6978C71.8417 8.38671 64.1583 8.38671 61.0232 13.6978L1.13711 115.152C-2.05077 120.553 1.84254 127.372 8.11386 127.372H127.886ZM68.1108 92.5135C73.5639 92.5135 77.9845 88.0929 77.9845 82.6398C77.9845 77.1867 73.5639 72.7661 68.1108 72.7661C62.6577 72.7661 58.237 77.1867 58.237 82.6398C58.237 88.0929 62.6577 92.5135 68.1108 92.5135Z"
              fill="#FFFFF2"
            />
          </clipPath>
        </svg>
        <img
          alt="image"
          className="archetype-image-large"
          src={`/archetypes/${props.archetype.slug}.jpg`}
          width="145px"
          height="145px"
        />
        <div className={styles.bottomTextDiv}>
          <p className={styles.bottomText}>
            {props.archetype.archetypeGroupSlug !== "work"
              ? props.archetype.acronym ?? props.archetype.name
              : `${props.archetype.name} (${props.archetype.acronym})`}
          </p>
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.architypeBody}>
        <p className={styles.topText}>
          {archetypeMapper[props.archetype.dimensionSlug]
            ? archetypeMapper[props.archetype.dimensionSlug].toUpperCase()
            : ""}
        </p>

        <svg
          width="90"
          height="78"
          viewBox="0 0 90 78"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <clipPath id="ArchetypeImageClipPathLarge">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M84.1172 77.6604C88.2137 77.6604 90.7568 73.1894 88.6744 69.6485L49.5568 3.1302C47.509 -0.351996 42.4902 -0.351994 40.4424 3.13021L1.32479 69.6485C-0.757529 73.1894 1.78558 77.6604 5.882 77.6604H84.1172ZM45.072 54.8056C48.6339 54.8056 51.5215 51.9073 51.5215 48.3319C51.5215 44.7566 48.6339 41.8582 45.072 41.8582C41.51 41.8582 38.6225 44.7566 38.6225 48.3319C38.6225 51.9073 41.51 54.8056 45.072 54.8056Z"
              fill="#FFFFF2"
            />
          </clipPath>
        </svg>

        <img
          alt="image"
          className="archetype-image-large"
          src={`/archetypes/${props.archetype.slug}.jpg`}
          width="89px"
          height="89px"
        />
        <div className={styles.bottomTextDiv}>
          <p className={styles.bottomText}>
            {props.archetype.archetypeGroupSlug !== "work"
              ? props.archetype.acronym ?? props.archetype.name
              : `${props.archetype.name} (${props.archetype.acronym})`}
          </p>
        </div>
        {props.score && <TraitScoreLarge score={props.score} />}
      </div>
    );
  }
}
